
























import {
  Modal,
  ModalMixin,
  AsyncBtn,
} from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { setup } from '.';

interface Data {
  task: Promise<void>|null,
  apiKey: string
}

export default ModalMixin.extend({
  props: {
    companyId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Campaign Monitor API Key',
    },
  },
  data(): Data {
    return {
      task: null,
      apiKey: '',
    };
  },
  computed: {
    canSave(): boolean {
      return (this.apiKey !== '');
    },
  },
  methods: {
    save(): void {
      if (!this.canSave) return;
      this.task = setup(this.companyId, this.apiKey);
      this.task.then(() => {
        this.$emit('ok');
        this.hide();
      });
    },
    isGranted,
  },
  components: {
    Modal,
    AsyncBtn,
  },
});
